import React,{useMemo} from 'react';
import SectionTitle from '../../components/Common/SectionTitle';
import Footer from '../../components/Layout/Footer';
import SearchModal from '../../components/Layout/Header/SearchModal';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import ServiceDetailsContent from './ServiceDetailsContent';

// Breadcrumbs Image
import breadcrumbsImg from '../../assets/img/breadcrumbs/2.jpg';
import serviceImg from '../../assets/img/service/4.png';
import DetailsHeader from '../../components/Layout/Header/DetailsHeader';

const MarketAnalysis = () => {
    const content = useMemo(() => {
        return <SectionTitle
            sectionClass="sec-title4"
            descClass="desc desc-big"
            description="Comprehensive market research and trend analysis to identify growth opportunities, assess competitors, and inform strategic decisions."
        />
    }, [])
    return (
        <React.Fragment>
            <DetailsHeader
                parentMenu='service'
                secondParentMenu='services'
                activeMenu='/market-analysis'
            />
            <SiteBreadcrumb
                breadcrumbsImg={breadcrumbsImg}
                pageTitle='Market Analysis & Research'
                pageCategory='Services'
                pageName='Market Analysis'
                parentPath="/service"
            />
            <ServiceDetailsContent title="Market Analysis & Research" subtitle="Market Analysis" children={content} serviceImg={serviceImg}/>
            <Footer footerClass="rs-footer" />
            <SearchModal />
        </React.Fragment>
    );
}

export default MarketAnalysis;
